
import { Outlet } from "react-router-dom"
import Header from "./Header"
import Footer from "./Footer"
import { Suspense } from "react"
import AutoLogout from "../Pages/LoginPage/AutoLogout"
import HeaderTemp from "./HeaderTemp"

export default function AppLayout() {    
    return (
        <>
            <AutoLogout />
            {/* <Header /> */}
            <HeaderTemp/>
            <main>
                <Suspense fallback={<div>Loading...</div>}>
                    <Outlet />
                </Suspense>
            </main>
            <Footer />
        </>
    )
}